import { render, staticRenderFns } from "./DownloadScheme.vue?vue&type=template&id=210d0782&lang=pug&"
import script from "./DownloadScheme.vue?vue&type=script&lang=js&"
export * from "./DownloadScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports